if(typeof _GIRL_CONF['victoria']['game_memory']=='undefined'){_GIRL_CONF['victoria']['game_memory']={};};
_GIRL_CONF['victoria']['game_memory']['arm']={left:583,top:253,width:214,height:170};
_GIRL_CONF['victoria']['game_memory']['face']={left:622,top:171,width:116,height:176};
_GIRL_CONF['victoria']['game_memory']['hair']={left:577,top:87,width:269,height:433};
_GIRL_CONF['victoria']['game_memory']['hand']={left:434,top:379,width:383,height:274};
_GIRL_CONF['victoria']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['victoria']['game_memory']['item2']={left:868,top:370,width:146,height:293};
_GIRL_CONF['victoria']['game_memory']['tit1']={left:609,top:401,width:134,height:114};
_GIRL_CONF['victoria']['game_memory']['tit2']={left:544,top:384,width:112,height:131};
